import React, { useEffect, useState } from 'react';
import { ModalBody, ModalHeader } from 'reactstrap';
import Rodal from '../../../../components/Rodal/Rodal';
import { LevelOfService } from '../../../../slices/marketplace/timeline/models/enums/level-of-service.enum';
import { useDispatch } from 'react-redux';
import { useStateSelector } from '../../../../store/selectors';
import { LoadMarketplacePricing } from '../../../../slices/marketplace/pricing/load-marketplace-pricing.thunk';
import createNotification from '../../../../utils/createNotification';
import Helpers from '../../../../utils/helper';
import ButtonLoader from '../../../../components/Layout/Buttons/ButtonLoader';
import {
    PricesCalculationHelper,
    ServicePriceDetails,
} from '../../../../utils/pricesCalculationHelper';
interface SuspendEngagementPopupProps {
    isVisible: boolean;
    setIsVisible(value: boolean): void;
    levelOfService: LevelOfService;
    engagementId: number;
    fteDvmNumber: number;
    fetchData(): void;
}

export const SuspendEngagementPopup = (props: SuspendEngagementPopupProps) => {
    const dispatch = useDispatch() as any;
    const marketplacePricing = useStateSelector(
        (state) => state.marketplacePricing.pricing
    );
    const [isLoading, setIsLoading] = useState(false);
    const axios = useStateSelector((state) => state.core.axios);
    const [servicePriceDetails, setServicePriceDetails] =
        useState<ServicePriceDetails>();

    useEffect(() => {
        dispatch(LoadMarketplacePricing(props.engagementId));
    }, []);

    useEffect(() => {
        calculatePricing();
    }, [marketplacePricing]);

    const calculatePricing = () => {
        const pricing =
            PricesCalculationHelper.getBrokeragePricingByLevelOfService(
                props.levelOfService,
                marketplacePricing
            );
        const servicePrice = PricesCalculationHelper.getSuspensionFeePrice(
            pricing,
            props.fteDvmNumber,
            1
        );

        setServicePriceDetails(servicePrice);
    };

    const renderMonthlySuspentionAmount = () => {
        if (!marketplacePricing) {
            return <>Loading...</>;
        }

        const isCreditable =
            props.levelOfService === LevelOfService.DiscountBrokerage;

        return (
            <>
                {Helpers.GetCurrencyFormat(
                    servicePriceDetails?.totalPrice,
                    2,
                    true
                )}{' '}
                per month, (
                {isCreditable
                    ? `${servicePriceDetails?.creditablePercent}%`
                    : 'not'}{' '}
                creditable)
            </>
        );
    };

    const suspendEngagement = () => {
        setIsLoading(true);
        axios
            .post(`/api/Marketplace/Engagements/${props.engagementId}/Suspend`)
            .then((response) => {
                if (response?.request?.status !== 200) {
                    createNotification(
                        'An error occured during suspension',
                        'error'
                    );
                    setIsLoading(false);
                } else {
                    props.fetchData();
                }
            })
            .catch(() => {
                createNotification(
                    'An error occured during suspension',
                    'error'
                );
            })
            .finally(() => {
                setIsLoading(false);
                props.setIsVisible(false);
            });
    };

    return (
        <>
            <Rodal
                visible={props.isVisible}
                onClose={() => props.setIsVisible(false)}
                animation="slideUp"
                className="suspend-engagement-popup"
                showMask={true}
                width={600}
                showCloseButton={true}>
                <ModalHeader>Suspend Engagement</ModalHeader>
                <ModalBody>
                    <div>
                        <div className="main-text">
                            The engagement suspension period commences with the
                            day you suspend the engagement and ends with the day
                            you resume the engagement. During the engagement
                            suspension period:
                        </div>
                        <ul className="mb-20 mt-20">
                            <li>
                                <div>
                                    You will have read-only access to your
                                    engagement dashboard on VV Connect, and you
                                    will not be able advance in the engagement
                                    process
                                </div>
                            </li>
                            <li>
                                <div>
                                    No further work will be performed on your
                                    engagement by VetValue
                                </div>
                            </li>
                            {props.levelOfService !==
                            LevelOfService.StrategicFinancialAdvisoryService ? (
                                <>
                                    {props.levelOfService ===
                                        LevelOfService.FullServiceBrokerage && (
                                        <li>
                                            <div>
                                                Monthly Engagement Fees will not
                                                be charged
                                            </div>
                                        </li>
                                    )}
                                    <li>
                                        <div>
                                            A Monthly suspension fees will be
                                            charged upon the suspension of the
                                            engagement and on each monthly
                                            anniversary thereof during the
                                            course of the suspension
                                        </div>
                                    </li>
                                </>
                            ) : (
                                <></>
                            )}
                        </ul>
                        {props.levelOfService !==
                        LevelOfService.StrategicFinancialAdvisoryService ? (
                            <div>
                                Monthly suspension fees for the engagement are:{' '}
                                {renderMonthlySuspentionAmount()}{' '}
                            </div>
                        ) : (
                            <></>
                        )}
                        <div className="suspend-buttons-section">
                            <button
                                className="btn btn-outline-secondary"
                                onClick={() => props.setIsVisible(false)}>
                                Continue Engagement
                            </button>
                            <ButtonLoader
                                type="submit"
                                className={
                                    'btn btn-primary select-documents-btn'
                                }
                                disabled={isLoading}
                                isLoading={isLoading}
                                loaderButtonText={''}
                                buttonText={'Suspend Engagement'}
                                onClick={suspendEngagement}
                            />
                        </div>
                    </div>
                </ModalBody>
            </Rodal>
        </>
    );
};
